import { render, staticRenderFns } from "./SmCardTicketCommentDetail.vue?vue&type=template&id=e5ed07b6&scoped=true&"
import script from "./SmCardTicketCommentDetail.vue?vue&type=script&lang=ts&"
export * from "./SmCardTicketCommentDetail.vue?vue&type=script&lang=ts&"
import style0 from "./SmCardTicketCommentDetail.vue?vue&type=style&index=0&id=e5ed07b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ed07b6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
